import { noop } from 'lodash';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';
import type { Room as RoomType } from '../../apiMethods/getRooms';
import ArrowWithTailIcon from '../../assets/arrow-tail.svg?react';
import { NotFoundPlug } from '../../components/Plug/NotFoundPlug';
import { Button } from '../../components/shared/Button/Button';
import { Skeleton } from '../../components/Skeleton';
import { Room } from '../../Room/Room';
import { ListWithCategories } from '../../stores/paramsStore';
import { Category } from './Category';

const RoomsNotfoundPlug = ({ onClick }: { onClick: () => void }) => {
  const title = () => (
    <span>
      не найдено номеров, <br /> подходящих под ваш запрос
    </span>
  );
  return (
    <NotFoundPlug title={title()} text="Пожалуйста, измените параметры запроса">
      <Button onClick={onClick} className="mx-auto flex items-center gap-2 px-4 py-3 ">
        <ArrowWithTailIcon /> Вернуться к параметрам
      </Button>
    </NotFoundPlug>
  );
};

const LoadingRoom = () => (
  <Room
    onRoomSelect={noop}
    loading={true}
    room={{
      id: 0,
      name: '',
      images: [],
      guest_limit: 0,
      for_disabled_people: true,
      min_price: 0,
      square: 0,
      nights: 0,
      sleeping_places: 0,
      short_description: '',
      view_type: '',
    }}
  />
);

type RoomListProps = {
  selectedRoomId?: number;
  roomList: ListWithCategories<RoomType>;
  nightsCount: number;
  isDisabled?: boolean;
  onRoomSelect: (id?: number) => void;
  onGoBack: () => void;
};

export const RoomList = observer(
  ({
    selectedRoomId,
    roomList,
    nightsCount,
    isDisabled,
    onRoomSelect,
    onGoBack,
  }: RoomListProps) => {
    return (
      <main className="container mx-auto max-w-[1168px] ">
        <section className="flex space-x-4 overflow-auto px-5 pb-8 xl:space-x-7 xl:px-0 xl:pb-5 3xl:absolute 3xl:left-[78px] 3xl:flex-col 3xl:space-x-0 3xl:space-y-4">
          {roomList.pending && (
            <>
              <Skeleton loading className="h-7 w-[80px]"></Skeleton>
              <Skeleton loading className="h-7 w-[80px]"></Skeleton>
            </>
          )}
          {!roomList.pending &&
            roomList.categories.map(category => (
              <Category
                key={category}
                selected={roomList.category === category}
                onClick={c => roomList.setCategory(c)}
              >
                {category}
              </Category>
            ))}
        </section>

        {roomList.pending && [1, 2, 3].map(x => <LoadingRoom key={x} />)}
        {!roomList.pending &&
          roomList
            .getListByCategory(selectedRoomId)
            .map(r => (
              <Room
                key={r.id}
                room={{ ...r, nights: nightsCount }}
                isSelected={r.id == selectedRoomId}
                isDisabled={isDisabled}
                onRoomSelect={onRoomSelect}
              />
            ))}

        {!roomList.pending && !roomList.getListByCategory().length && (
          <RoomsNotfoundPlug onClick={onGoBack} />
        )}

        <Outlet />
      </main>
    );
  },
);
